package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 提现记录数据模型
 */
@Serializable
data class WithdrawRecord(
    val id: Int,                          // 提现ID
    val userId: Int,                      // 用户ID
    val amount: Double,                   // 提现金额
    val status: Int,                      // 状态：0-待审核，1-成功，2-失败
    val statusText: String? = null,       // 状态文本
    val createdAt: String,                // 创建时间
    val handleTime: String? = null,       // 处理时间（可能为null）
    val cardNumber: String? = null,       // 银行卡号（可能为null）
    val bankName: String? = null          // 银行名称（可能为null）
)

/**
 * 申请提现响应
 */
@Serializable
data class ApplyWithdrawResponse(
    val code: Int? = null,         // 状态码
    val message: String? = null,   // 消息
    val data: String? = null       // 数据
)

/**
 * 提现记录列表响应模型
 */
@Serializable
data class WithdrawRecordListResponse(
    val code: Int? = null,                  // 状态码
    val message: String? = null,            // 消息
    val data: List<WithdrawRecord>? = null  // 提现记录列表
)